export default __webpack_public_path__ + "static/media/Expertise.4636a7a5.jpg";